<template>
  <div class="page-header">
    <img :src="backgroundSrc" class="page-header-background" />
    <div class="page-header-container">
      <div class="header-button table-name" v-if="$store.getters.padSetting.menuMode !== true">
        <div class="-line1">{{ $t("PAD.table_name") }}</div>
        <div class="-line2">{{ currentTableName }}</div>
      </div>
      <div v-if="$store.getters.padSetting.menuMode !== true && $store.state.Pad.timeLimit" class="header-button time-info">
        <div class="-line1">{{ $t("PAD.remain_time") }}</div>
        <div class="-line2">
          <span style="font-size: 2.4em;">{{ $store.state.Pad.timeRemain }}</span
          ><span style="font-size: 0.8em;" class="ml-2">{{ $t("PAD.minutes") }}</span>
        </div>
      </div>
      <div v-if="$store.getters.languages.length > 1" class="header-button language" @click="setNextLanguage">
        <img src="@/assets/icon/pageHeader/language.svg" width="32" height="32" />
        <div class="-line1">{{ $t("language") }}</div>
      </div>
      <div v-if="$store.getters.padSetting.menuMode !== true" class="header-button order-history" @click="historyClicked">
        <v-icon> mdi-receipt-clock-outline </v-icon>
        <div class="-line1">{{ $t("order_history") }}</div>
      </div>

      <!--
      <div v-if="services && services.length == 1 && services[0].code == 'other'" class="header-button server" @click="sendMessage('other')">
        <v-icon> mdi-room-service </v-icon>
        <div class="-line1">{{ $t("PAD.server") }}</div>
      </div>
      -->
      <v-menu v-if="$store.getters.padSetting.menuMode !== true && services && services.length > 0" content-class="server-menu" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <div class="header-button server">
              <v-icon> mdi-room-service </v-icon>
              <div class="-line1">{{ $t("PAD.server") }}</div>
            </div>
          </div>
        </template>

        <v-list>
          <v-list-item v-for="(service, index) in services" :key="index" @click="sendMessage(service.code)">
            <div class="service-wrapper">
              <v-icon>{{ service.icon }} </v-icon>
              <div class="-title">{{ $t(service.title) }}</div>
            </div></v-list-item
          >
        </v-list>
      </v-menu>

      <div style="margin:auto;"></div>

      <v-menu v-if="$store.getters.padSetting.menuMode !== true && guestVisible" content-class="number-of-guests-menu" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <div @click="getNumberOfGuests" class="header-button number-of-guests">
              <div class="-line1">{{ $t("PAD.GUESTS.num_of_guests") }}</div>
              <div v-if="guestTotal > 0" class="-line2">{{ guestTotal }}</div>
            </div>
          </div>
        </template>

        <v-list v-if="guestTotal > 0">
          <v-list-item v-if="$store.state.Pad.numberOfGuests.adult > 0"
            ><span class="guest-number">{{ $store.state.Pad.numberOfGuests.adult }}</span
            >{{ $t("PAD.GUESTS.adults") }}</v-list-item
          >
          <v-list-item v-if="$store.state.Pad.numberOfGuests.senior > 0"
            ><span class="guest-number">{{ $store.state.Pad.numberOfGuests.senior }}</span>
            {{ $t("PAD.GUESTS.seniors") }}</v-list-item
          >
          <v-list-item v-if="$store.state.Pad.numberOfGuests.junior > 0"
            ><span class="guest-number">{{ $store.state.Pad.numberOfGuests.junior }}</span>
            {{ $t("PAD.GUESTS.juniors") }}</v-list-item
          >
        </v-list>
      </v-menu>
    </div>

    <HistoryDialog ref="historyDialog"></HistoryDialog>
  </div>
</template>

<script>
import mDialog from "@/modules/dialog";

import HistoryDialog from "@/dialogs/HistoryDialog";

export default {
  components: {
    HistoryDialog,
  },

  computed: {
    pageSchema() {
      return this.$store.getters.padMenuSchema;
    },

    backgroundSrc() {
      let image = this.pageSchema.topBackground?.image;
      if (image && (image.fileSize > 0 || image.altUrl)) return image.downloadPath;
      else return undefined;
    },

    currentTableID() {
      return this.$store.state.Pad.currentTable?.ID;
    },

    currentTableName() {
      return this.$store.state.Pad.currentTable?.descr;
    },

    services() {
      let _services = [];

      if (this.$store.getters.padCallService) {
        if (this.$store.getters.padCallService.find(x => x == "water"))
          _services.push({ icon: "mdi-beer", title: "PAD.water", code: "water" });
        if (this.$store.getters.padCallService.find(x => x == "cleanup"))
          _services.push({ icon: "mdi-spray-bottle", title: "PAD.clean_up", code: "cleanup" });
        if (this.$store.getters.padCallService.find(x => x == "utensils"))
          _services.push({ icon: "mdi-silverware-fork-knife", title: "PAD.utensils", code: "utensils" });
        if (this.$store.getters.padCallService.find(x => x == "checkout"))
          _services.push({ icon: "mdi-receipt-text-outline", title: "checkout", code: "checkout" });
        if (this.$store.getters.padCallService.find(x => x == "other"))
          _services.push({ icon: "mdi-help-circle", title: "PAD.other", code: "other" });
      }

      return _services;
    },

    guestVisible() {
      if (
        this.$store.getters.padSetting &&
        this.$store.getters.padSetting
          .guest /* &&
        this.$store.state.Pad.currentTable &&
        this.$store.state.Pad.currentTable.dataID*/
      ) {
        let g = this.$store.getters.padSetting.guest;
        return (
          (Array.isArray(g.adult) && g.adult.length > 0) ||
          (Array.isArray(g.senior) && g.senior.length > 0) ||
          (Array.isArray(g.junior) && g.junior.length > 0)
        );
      } else return false;
    },

    guestTotal() {
      if (this.$store.state.Pad.numberOfGuests) {
        let total = 0;
        if (this.$store.state.Pad.numberOfGuests.adult > 0) total += this.$store.state.Pad.numberOfGuests.adult;
        if (this.$store.state.Pad.numberOfGuests.senior > 0) total += this.$store.state.Pad.numberOfGuests.senior;
        if (this.$store.state.Pad.numberOfGuests.junior > 0) total += this.$store.state.Pad.numberOfGuests.junior;
        return total;
      }
      return 0;
    },
  },

  methods: {
    historyClicked() {
      this.$store.dispatch("PAD_GET_ORDER");
      this.$refs.historyDialog.open();
    },

    sendMessage(message) {
      this.$store.dispatch("PAD_SEND_MESSAGE", message);
      mDialog.messageDialog.open("Message was sent");
    },

    checkPos() {
      console.log(window);
    },

    getNumberOfGuests() {
      this.$store.dispatch("PAD_GET_NUM_OF_GUESTS");
    },
  },
};
</script>

<style lang="scss" scoped>
$header-height: 90px;
.page-header {
  height: $header-height;
  overflow: hidden;
  position: relative;

  .page-header-background {
    position: absolute;
    object-fit: cover;
    width: 100%;
    height: 100%;
    //height: $header-height;
  }

  .page-header-container {
    position: relative;
    width: 100%;
    height: 100%;

    display: flex;

    line-height: normal;

    .table-name {
      min-width: 90px;
      text-align: center;

      .-line1 {
        font-size: 0.6em;
      }

      .-line2 {
        font-size: 2.4em;
      }
    }
    .time-info {
      width: 160px;

      .-line1 {
        font-size: 0.6em;
      }
    }

    .language {
      width: 90px;
      align-items: center;

      .v-icon {
        color: white;
        font-size: 2em;
      }

      .-line1 {
        font-size: 0.8em;
        margin-bottom: 6px;
      }
    }

    .order-history {
      width: 120px;
      text-align: center;

      .v-icon {
        color: white;
        font-size: 2em;
      }

      .-line1 {
        font-size: 0.8em;
        margin-bottom: 6px;
      }
    }

    .server {
      width: 90px;
      text-align: center;

      .v-icon {
        color: white;
        font-size: 2em;
      }

      .-line1 {
        font-size: 0.8em;
        margin-bottom: 6px;
      }
    }

    .number-of-guests {
      width: 150px;
      text-align: center;

      margin-left: auto;

      .-line1 {
        font-size: 0.6em;
        line-height: normal;
      }

      .-line2 {
        font-size: 2.4em;
        line-height: normal;
      }
    }
  }

  .header-button {
    height: 100%;

    padding: 12px;

    background-color: rgba(0, 0, 0, 0.2);
    color: var(--v-primaryText-base);
    border-right: solid 1px rgba(255, 255, 255, 0.2);

    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}

.server-menu {
  .v-list {
    background-color: var(--v-primary-base);
    color: var(--v-primaryText-base);
    opacity: 0.85;
    padding-bottom: 0px;

    .v-list-item {
      color: var(--v-primaryText-base) !important;
      justify-content: center;
      border-bottom: solid 1px rgba(255, 255, 255, 0.2);
      padding: 12px 0px;

      .service-wrapper {
        display: flex;
        flex-direction: column;
        font-size: 0.8em;

        .v-icon {
          color: white;
          padding-bottom: 12px;
        }

        .-title {
          text-align: center;
        }
      }
    }
  }
}

.number-of-guests-menu {
  right: 0px;
  left: unset !important;
  width: 150px;
  .v-list {
    background-color: var(--v-primary-base);
    color: var(--v-primaryText-base);
    opacity: 0.85;

    .v-list-item {
      color: var(--v-primaryText-base) !important;

      .guest-number {
        text-align: center;
        font-size: 2em;
        width: 60px;
      }
    }
  }
}
</style>
